import styled from "styled-components";
import React from "react";
import logoImg from '../../img/logo.png';
function Menu() {
    return (
        <Nav>
            <div className="layout">
                <a href="/">
                    <img
                        className="logo"
                        src={logoImg}
                        alt=""
                    />
                </a>
            </div>
        </Nav>
        );
}

const Nav = styled.div `
    background-color:var(--main-color);
    color:white;
    
    padding:16px 20px;   
`;
export default Menu;
